export const BENCHMARKS_COLOR_PALETTE = [
  "#74A2ED",
  "#939393",
  "#A456F4",
  "#ADE38E",
];

export const ASSETS_COLOR_PALETTE = [
  "#2E56A2",
  "#6C6C6C",
  "#48BCC9",
  "#3F7222",
  "#531394",
  "#CFE9EB",
  "#C9C9C9",
  "#8ED1E5",
  "#DCFFC7",
  "#D1B7EB",
  "#BAD4FF",
  "#74A2ED",
  "#939393",
  "#A456F4",
  "#ADE38E",
  "#BAD8FF",
  "#1F2A4D",
  "#6F27B8",
  "#4B4B4B",
  "#81C25C",
];

export const RED_CORRELATION_GRAPH = "#E35D81";
export const ORANGE_CORRELATION_GRAPH = "#EE8C68";
export const YELLOW_CORRELATION_GRAPH = "#FCD401";
export const GREEN_CORRELATION_GRAPH = "#4DDC8F";
export const BLUE_CORRELATION_GRAPH = "#4EAFE0";
export const BLUE_QUANTUM = "#254057";
export const INITIAL_BENCHMARK_INDEX = 0;

export const CATEGORY_COLORS = {
  ACAO: "#F09C62",
  FUNDO: "#604AF0",
  EUROPA: "#604AF0",
  PREVIDENCIA: "#32A32A",
  RENDA_FIXA: "#BE56F0",
  BENCHMARK_PERSONALIZADO: "#3E85F0",
};

export const URL_FIELDS_SIZE = 5;
export const AMOUNT_MIN = 0;
export const AMOUNT_MAX = 1000000;
export const VALID_TABS = [
  "RENTABILIDADE",
  "RETORNO",
  "UNDERWATER",
  "CORRELATION",
];
export const VALID_BENCHMARKS = ["CDI", "IBOV", "IPCA", "DOLAR"];
export const VALID_PERIODS = [
  "OTIMO",
  "NO_MES",
  "UM_ANO_UTIL",
  "SEIS_MESES_UTEIS",
  "CINCO_ANOS_UTEIS",
];

export const PERIOD_OPTIMAL = "OTIMO";

export const QR_CODE_SQUARE_SIZE = 208;

export const BENCHMARKS_ASSETS_IDS = [1, 4, 31, 7];

export const WHATSAPP_API_URL = "https://api.whatsapp.com/send?text=";

export const contextButtonIcon =
  "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";

export const COLUMN_WIDTHS = {
  Rentabilidade: 96,
  Volatilidade: 82,
  Sharpe: 49,
  "Taxa de Admin": 102,
  "PL Milhões": 75,
  Retorno: 56,
  "Retorno 1 Ano": 99,
  "Retorno YTD": 87,
  Drawdown: 80,
  "Início do Máximo Drawdown": 202,
  "Data do Máximo Drawdown": 197,
  "Máximo Drawdown": 140,
};
